// src/helpers/renderDynamicIcons.js
import React from 'react';
import * as MuiIcons from '@mui/icons-material';

export function renderIcon(icon, extraProps) {
  if (!icon) return null;
  
  if (React.isValidElement(icon)) {
    return React.cloneElement(icon, { ...extraProps, ...(icon.props || {}) });
  }
  
  if (typeof icon === 'string') {
    const IconComponent = MuiIcons[icon];
    if (!IconComponent) {
      console.warn(`Icon "${icon}" not found`);  // FIXED: Added (
      return null;
    }
    return React.createElement(IconComponent, extraProps);
  }
  
  return React.createElement(icon, extraProps);
}